import { render, staticRenderFns } from "./FieldPropertyvisibility.vue?vue&type=template&id=c2472c62&scoped=true&"
import script from "./FieldPropertyvisibility.vue?vue&type=script&lang=js&"
export * from "./FieldPropertyvisibility.vue?vue&type=script&lang=js&"
import style0 from "./FieldPropertyvisibility.vue?vue&type=style&index=0&id=c2472c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2472c62",
  null
  
)

export default component.exports